import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { SelectorField, TextSearchField } from '@anytag/shared-molecules';
import { useTikTokCampaignStatusOptions } from './hooks';
import { TikTokCampaignsFilterFormKeys } from './schemaTypes';

export interface TemplateProps {
  onSubmit?: () => void;
}

export const Template = ({ onSubmit }: TemplateProps) => {
  const { t } = useTranslation();
  const { statusOptions } = useTikTokCampaignStatusOptions();

  return (
    <Form.Fields>
      <TextSearchField<TikTokCampaignsFilterFormKeys>
        name="keyword"
        onSubmit={onSubmit}
        placeholder={t<string>('Search.TiktokCampaignsFilter')}
      />
      <SelectorField<TikTokCampaignsFilterFormKeys>
        name="status"
        onSubmit={onSubmit}
        options={statusOptions}
        className="max-w-46"
        placeholder={t<string>('Selector.Status')}
      />
    </Form.Fields>
  );
};
